import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { forkJoin, Observable, Subject } from 'rxjs';
import { AwsService, ContribuyentesService, ListasService, UsuarioService } from 'src/app/services/service.index';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import swal2 from 'sweetalert2';
import { TiposArchivosPcGuard } from '../../services/guards/tiposarchivospc.guard';

@Component({
  selector: 'app-modregempdet',
  templateUrl: './modregempdet.component.html',
  styleUrls: ['./modregemp.component.css']
})
export class ModregempdetComponent implements OnInit {

  idu = this._router.snapshot.paramMap.get('id');
  colonias = [];
  capturaCp = false;
  municipios = [];
  paises = [];

  customerFG = new FormGroup({
    assist_bonus: new FormControl(),
    attached: new FormControl(),
    attention: new FormControl(),
    benefit: new FormControl(),
    benefit_detail: new FormControl(),
    card_number: new FormControl(),
    ccv: new FormControl(),
    child_support: new FormControl(),
    christmas_bonus: new FormControl(),
    company_id: new FormControl(),
    contributor_id: new FormControl(),
    credit_cp: new FormControl(),
    credit_lp: new FormControl(),
    customer_type: new FormControl(),
    detail_extra_deductions: new FormControl(),
    detail_extra_income: new FormControl(),
    extra1: new FormControl(),
    extra2: new FormControl(),
    extra3: new FormControl(),
    extra_deductions: new FormControl(),
    extra_expenses: new FormControl(),
    extra_income: new FormControl(),
    family_expenses: new FormControl(),
    food_vouchers: new FormControl(),
    house_rent: new FormControl(),
    immediate_superior: new FormControl(),
    imms: new FormControl(),
    infonavit: new FormControl(),
    insurance_discount: new FormControl(),
    job: new FormControl(),
    name: new FormControl(),
    net_expenses: new FormControl(),
    ontime_bonus: new FormControl(),
    other_income: new FormControl(),
    other_income_detail: new FormControl(),
    oustanding_balance: new FormControl(),
    payment_method: new FormControl(),
    public_charge: new FormControl(),
    public_charge_det: new FormControl(),
    relative_charge: new FormControl(),
    relative_charge_det: new FormControl(),
    responsible: new FormControl(),
    responsible_detail: new FormControl(),
    salary: new FormControl(),
    salary_period: new FormControl(),
    savings_bank: new FormControl(),
    savings_found: new FormControl(),
    savings_found_loand: new FormControl(),
    seniority: new FormControl(),
    status: new FormControl(),
    substitute_owner: new FormControl(),
    taxes: new FormControl(),
    total_income: new FormControl(),
    total_savings_found: new FormControl(),
    validiy: new FormControl(),
  });

  contributorFG = new FormGroup({
    account_number: new FormControl(),
    bank: new FormControl(),
    clabe: new FormControl(),
    contributor_addresses: new FormControl(),
    contributor_documents: new FormControl(),
    contributor_type: new FormControl(),
    extra1: new FormControl(),
    extra2: new FormControl(),
    extra3: new FormControl(),
    legal_entity_id: new FormControl(),
    person: new FormControl(),
    person_id: new FormControl(),
    bank_key: new FormControl(),
  });

  contributorAddressFG = new FormGroup({
    address_reference: new FormControl(),
    address_type: new FormControl(),
    apartment_number: new FormControl(),
    contributor_id: new FormControl(),
    external_number: new FormControl(),
    municipality_id: new FormControl(),
    postal_code: new FormControl(),
    state_id: new FormControl(),
    street: new FormControl(),
    suburb: new FormControl(),
    suburb_type: new FormControl(),
  });

  personFG = new FormGroup({
    birth_country: new FormControl(),
    birthdate: new FormControl(),
    birthplace: new FormControl(),
    citizen_id: new FormControl(),
    curp: new FormControl(),
    email: new FormControl(),
    extra1: new FormControl(),
    extra2: new FormControl(),
    extra3: new FormControl(),
    fiel: new FormControl(),
    first_name: new FormControl(),
    fiscal_regime: new FormControl(),
    gender: new FormControl(),
    housing_type: new FormControl(),
    id_type: new FormControl(),
    identification: new FormControl(),
    imss: new FormControl(),
    last_name: new FormControl(),
    martial_regime: new FormControl(),
    martial_status: new FormControl(),
    minior_dependents: new FormControl(),
    mobile: new FormControl(),
    nationality: new FormControl(),
    ocr: new FormControl(),
    phone: new FormControl(),
    rfc: new FormControl(),
    second_last_name: new FormControl(),
    senior_dependents: new FormControl(),
  });

  datosCreditoFG = new FormGroup({
    customer: this.customerFG,
    contributor: this.contributorFG,
  });

  personalReferencesArray = new FormGroup({
    referencias: new FormArray([])
  });

  formGroups = [
    'person',
    'contributorAddress',
    'personalReferences',
    'customer',
    'contributor',
    'customer'
  ];

  estados = [];
  pais: any;
  myForm: any;
  martial_status = [];
  martial_regimen = [];
  dependientes = false;
  addressTypes = [];
  bancos = [];
  generos = [];
  activeStep: number;
  initialValues = { };
  pendingUpdates = {};
  customer_id: any;
  person_id: any;
  contributor_id: any;
  contributorAddress_id: any;
  @ViewChild('stepper') stepper: MatStepper;
  currentStep = 0;
  companies: any;
  company: any;
  contributor_documents = [];
  archivosCargados = [];
  ingresos = [];
  pendingXmlFile: { file: File, idd: any } = null;
  pendingIngresos = false;
  ingresosYaCargados = false;
  cliente = false;
  visualizador = false;
  pdfSrc: any;
  file = {};
  inputProvisional: any;
  fileDetails: {  };
  
  constructor( private aws: AwsService, 
               private _router: ActivatedRoute,
               public router: Router,
               private _formBuilder: FormBuilder,
              private listasService: ListasService,
              private contribuyenteService: ContribuyentesService,
              private usuarioService: UsuarioService,
              private sanitizer: DomSanitizer ) {}

  ngOnInit(): void {
    swal2.showLoading();
    if(this._router.snapshot.paramMap.get('cliente')){
      console.log('cliente');
      this.cliente = true;
    }
    var observableMartialStatus = this.listasService.getListsByDomain('PERSON_MARTIAL_STATUS');
    var observableMartialRegime = this.listasService.getListsByDomain('PERSON_MARITAL_REGIME');
    var observablePaises = this.aws.getCountriesD();
    var observableBancos = this.aws.getBankNumber();
    var observableGeneros = this.aws.getUserGender();
    var observableAddressType = this.listasService.getListsByDomain('CONTRIBUTOR_ADDRESS_ADDRESS_TYPE');
    var observableCompanies = this.aws.getCompanyes();
    forkJoin([observableMartialStatus, observableMartialRegime, observablePaises, observableAddressType, observableBancos, observableGeneros, observableCompanies])
    .subscribe( ([status, regimen, paises, addressType, bancos, generos, companies]) => {
      status['data'].forEach( m => {
        this.martial_status.push(m.attributes);
      })
      regimen['data'].forEach( r => {
        this.martial_regimen.push(r.attributes);
      })
      this.paises = paises; 
      addressType['data'].forEach( a => {
        this.addressTypes.push(a.attributes);
      })
      this.bancos = bancos;
      generos['data'].forEach( b => {
        this.generos.push(b.attributes);
      })
      this.companies = companies;
      this.aws.getCustomerByUserId(this.idu).subscribe(res => {
        if(res.length == 0){this.router.navigate(['/modregemp']); return;}
        this.contributor_documents = res[0].contributor.contributor_documents;
        if(!this.cliente){
          console.log('no es cliente', this.contributor_documents);
          this.archivosCargados = this.contributor_documents.filter(d => d.status == 'IN').map(d => d.id);
          var docIngresos = this.contributor_documents.find(d => d.name.toLowerCase().includes('ingresos'));
          this.ingresosYaCargados = docIngresos && docIngresos.status == 'IN' && docIngresos.url && docIngresos.url !== '';
        }
        this.customerFG.patchValue(res[0]);
        this.customer_id = res[0].id;
        this.customerFG.patchValue({
          salary_period: (this.customerFG.get('salary_period').value || '').toString().toUpperCase()
        });
        this.company = this.companies.find(c =>c.id == this.customerFG.get('company_id').value);
        this.contributorFG.patchValue(res[0].contributor);
        this.contributor_id = res[0].contributor.id;
        this.personFG.patchValue(res[0].contributor.person);
        this.person_id = res[0].contributor.person_id;
        this.contributorAddressFG.patchValue(res[0].contributor.contributor_addresses[0]);
        this.contributorAddress_id = res[0].contributor.contributor_addresses[0].id;
        this.contributorAddressFG.patchValue({
          address_type: (this.contributorAddressFG.get('address_type').value || '').toString().toUpperCase()
        });
        this.getColonias(this.contributorAddressFG.get('postal_code').value);
        this.getPais(this.personFG.get('birth_country').value, this.estados.find(e => e.id === this.contributorAddressFG.get('state_id').value)?.name || '', this.municipios.find(m => m.id === this.contributorAddressFG.get('municipality_id').value)?.name || '');
        if (this.personFG.get('minior_dependents').value > 0 || this.personFG.get('senior_dependents').value > 0) {
          this.dependientes = true;
        }
        res[0].customer_personal_references.forEach(r => {
          (this.personalReferencesArray.get('referencias') as FormArray).push(
            new FormGroup({
              first_name: new FormControl(r.first_name),
              last_name: new FormControl(r.last_name),
              second_last_name: new FormControl(r.second_last_name),
              address: new FormControl(r.address),
              phone: new FormControl(r.phone),
              reference_type: new FormControl(r.reference_type),
              id: new FormControl(r.id),
            })
          )
        });
        setTimeout(() => {
  
          // 3. Ahora sí, guarda initial values correctamente normalizados
          this.initialValues = {
            0: JSON.parse(JSON.stringify(this.personFG.value)),
            1: JSON.parse(JSON.stringify(this.contributorAddressFG.value)),
            2: JSON.parse(JSON.stringify(this.personalReferencesArray.value)),
            3: JSON.parse(JSON.stringify(this.customerFG.value)),
            4: JSON.parse(JSON.stringify(this.contributorFG.value)),
          };
  
          // 4. Y AHORA registra los valueChanges
          this.personFG.valueChanges.subscribe(value => {
            this.collectChanges(0, value);
          });
          this.contributorAddressFG.valueChanges.subscribe(value => {
            this.collectChanges(1, value);
          });
          this.personalReferencesArray.valueChanges.subscribe(value => {
            this.collectChanges(2, value);
          });
          this.customerFG.valueChanges.subscribe(value => {
            this.collectChanges(3, value);
          });
          this.contributorFG.valueChanges.subscribe(value => {
            this.collectChanges(4, value);
          });
  
        }, 0);
        swal2.close();
      })
    });
  }

  get hasPendingUpdates(): boolean {
    return Object.keys(this.pendingUpdates ?? {}).length > 0;
  }

  collectChanges(groupIndex: number, currentValue: any) {
    if (!this.pendingUpdates[groupIndex]) {
      this.pendingUpdates[groupIndex] = {};
    }

    const initial = this.initialValues[groupIndex];

    this.compareValues(currentValue, initial, this.pendingUpdates[groupIndex]);
  }

  compareValues(current: any, initial: any, target: any) {
    // Normalizar initial para evitar errores al indexar
    initial = initial ?? {};

    Object.keys(current).forEach(key => {
      const currValue = current[key];
      const initValue = initial[key];

      // 🔵 Caso 1: FormArray
      if (Array.isArray(currValue)) {
        const arrayChanges: any[] = [];

        // Si initValue no es array, normalizar para evitar crashes
        const initArray = Array.isArray(initValue) ? initValue : [];

        currValue.forEach((item, index) => {
          // Si no hay init para este índice, pasar {} para que la comparación no falle
          const initItem = initArray[index] ?? {};

          const itemChanges: any = {};
          // Llamada recursiva segura — pasamos initItem
          this.compareValues(item, initItem, itemChanges);

          // Solo pushear si hubo cambios
          if (Object.keys(itemChanges).length > 0) {
            arrayChanges.push({
              id: (item && item.id) ? item.id : null, // aceptar null si no hay id
              changes: itemChanges
            });
          }
        });

        if (arrayChanges.length > 0) {
          target[key] = arrayChanges;
        }

        return; // importante: ya procesamos este key
      }

      // 🔵 Caso 2: FormGroup (objeto)
      else if (typeof currValue === 'object' && currValue !== null) {
        const nestedChanges: any = {};
        // Usamos initValue si existe, sino {}
        this.compareValues(currValue, initValue ?? {}, nestedChanges);

        if (Object.keys(nestedChanges).length > 0) {
          target[key] = nestedChanges;
        }

        return;
      }

      // 🔵 Caso 3: Valor simple
      else {
        // Si initValue es undefined explícito, compara con undefined también
        if (currValue !== initValue) {
          target[key] = currValue;
        }
      }

    });
  }

  goNext(stepper: MatStepper) {
    this.handleStepChange(stepper, 'next');
  }

  goPrevious(stepper: MatStepper) {
    this.handleStepChange(stepper, 'prev');
  }

  handleStepChange(stepper: MatStepper, direction: 'next' | 'prev') {
    const currentIndex = stepper.selectedIndex;
    const pending = this.pendingUpdates[currentIndex];

    if (pending && Object.keys(pending).length > 0) {
      swal2.fire({
        title: 'Cambios sin guardar',
        text: 'Tienes cambios sin guardar. ¿Deseas guardarlos ahora?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Descartar',
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(result => {
        if (result.isConfirmed) {
          this.guardaCambios().then(() => {
            this.pendingUpdates[currentIndex] = {};
            this.moveStep(stepper, direction);
          });
        } else if (result.isDismissed) {
          this.pendingUpdates[currentIndex] = {};
          this.resetStep(currentIndex);
          this.moveStep(stepper, direction);
        }
      });
    } else {
      // No hay cambios → avanzar
      this.moveStep(stepper, direction);
    }
  }

  resetStep(stepIndex: number) {
    switch(stepIndex) {
      case 0:
        this.personFG.patchValue(this.initialValues[0]);
        break;
      case 1:
        this.contributorAddressFG.patchValue(this.initialValues[1]);
        break;
      case 2:
        const array = this.personalReferencesArray.get('referencias') as FormArray;
        array.clear();
        this.initialValues[2].forEach((val: any) => {
          array.push(new FormGroup({
            first_name: new FormControl(val.first_name),
            last_name: new FormControl(val.last_name),
            second_last_name: new FormControl(val.second_last_name),
            address: new FormControl(val.address),
            phone: new FormControl(val.phone),
            reference_type: new FormControl(val.reference_type),
            id: new FormControl(val.id),
          }));
        });
        break;
      case 3:
        this.customerFG.patchValue(this.initialValues[3]);
        break;
      case 4:
        this.contributorFG.patchValue(this.initialValues[4]);
        break;
    }
  }

  moveStep(stepper: MatStepper, direction: 'next' | 'prev') {
    if (direction === 'next') stepper.next();
    else stepper.previous();
  }

  onStepChange(event: StepperSelectionEvent) {
  const nextStep = event.selectedIndex;
  const prevStep = event.previouslySelectedIndex;

  // Si hay cambios pendientes
  if (this.pendingUpdates[prevStep] && Object.keys(this.pendingUpdates[prevStep]).length > 0) {
    // Cancelar el cambio momentáneamente
    setTimeout(() => this.currentStep = prevStep); // vuelve al step anterior

    swal2.fire({
      title: 'Cambios sin guardar',
      text: 'Tienes cambios sin guardar. ¿Deseas guardarlos ahora?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      cancelButtonText: 'Descartar',
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(result => {
      if (result.isConfirmed) {
        this.guardaCambios().then(() => {
          this.pendingUpdates[prevStep] = {};
          this.currentStep = nextStep; // avanzar al step deseado
        });
      } else {
        this.pendingUpdates[prevStep] = {};
        this.currentStep = nextStep; // avanzar al step deseado
      }
    });
  } else {
    this.currentStep = nextStep;
  }
  }

  updateTable(stepIndex: number, changes: any) {
    // Llamar tu endpoint correspondiente dependiendo del step
    console.log("Actualizando tabla:", stepIndex, "con:", changes);

    // luego reseteas los cambios aplicados
    this.pendingUpdates[stepIndex] = {};
  }

  dragEnter(id: string) {
    document.getElementById(id).style.border = "dashed 3px #73CB38";
  }
  dragLeave(id: string) {
    document.getElementById(id).style.border = "dashed 1px #979797";
  }
  drop(id: string) {
    document.getElementById(id).style.border = "dashed 1px #979797";
  }

  getColonias(event) {
    this.aws.getColoniasxcp(event).subscribe(r => {
       this.colonias = r;
       this.capturaCp = false;
       if(this.colonias.length == 0){
         this.capturaCp = true;
       }
     })
   }

  buscaMun(id) {
  this.aws.getMunicipios(id).subscribe( r => {this.municipios = r;} )
  }

  buscaEdo(id) {
  console.log(id)
  this.aws.getStatesId(id).subscribe( r => {this.estados = r;} )
  }

  normalize(text: string): string {
    return text
      .normalize('NFD')                 // separa los acentos
      .replace(/[\u0300-\u036f]/g, '')  // elimina los acentos
      .toUpperCase()                    // convierte a mayúsculas
      .trim();                          // opcional, quita espacios
  }

  getPais(pais: string, estado: string, municipio: string) {
  this.pais = this.paises.find( p => this.normalize('México') === this.normalize(p.name.toLowerCase())).id;
  this.aws.getStatesId(this.pais).subscribe( respstates => { 
    this.estados = respstates;
    this.aws.getMunicipios(this.contributorAddressFG.get('state_id').value).subscribe( respmun => {
      this.municipios = respmun;
    })
  })
  }

   /* fileBrowseHandler( e: any, name: string, url: string) {

      switch (name) {
        case 'Identificacion oficial':
           if ((e[0].type).toLowerCase().includes('pdf')) {
            this.myForm.patchValue({ fileIne: e[0] });
            break;
          } else {
            swal2.fire('El archivo tiene que ser un PDF','','info');
            break;
          }
         case 'Comprobante de domicilio':
           if ((e[0].type).toLowerCase().includes('pdf')) {
             this.myForm.patchValue({ fileCompDom: e[0] });
          break;
           } else {
             swal2.fire('El archivo tiene que ser un PDF','','info');
             break;
           }
          case 'Curp del empleado':
           if ((e[0].type).toLowerCase().includes('pdf')) {
             this.myForm.patchValue({ fileCurp: e[0] });
            break;
           } else {
             swal2.fire('El archivo tiene que ser un PDF','','info');
             break;
           }
          case 'Estado de cuenta bancario':
           if ((e[0].type).toLowerCase().includes('pdf')) {
             this.myForm.patchValue({ fileEcuenta: e[0] });
             break;
           } else {
             swal2.fire('El archivo tiene que ser un PDF','','info');
             break;
           }
          case 'XML del empleado':
           if ((e[0].type).toLowerCase().includes('xml')) {
             this.myForm.patchValue({ fileXml: e[0] });
          break;
           } else {
             swal2.fire('El archivo tiene que ser un XML','','info');
             break;
           }
           case 'Validacion rfc':
            if ((e[0].type).toLowerCase().includes('pdf')) {
              this.myForm.patchValue({ fileVrfc: e[0] });
              break;
            } else {
              swal2.fire('El archivo tiene que ser un PDF','','info');
              break;
            }
            case 'Validacion ine':
           if ((e[0].type).toLowerCase().includes('pdf')) {
             this.myForm.patchValue({ fileVine: e[0] });
             break;
           } else {
             swal2.fire('El archivo tiene que ser un PDF','','info');
             break;
           }
           case 'Constancia de situación fiscal':
           if ((e[0].type).toLowerCase().includes('pdf')) {
             this.myForm.patchValue({ fileCsf: e[0] });
             break;
           } else {
             swal2.fire('El archivo tiene que ser un PDF','','info');
             break;
           }
           case 'Listas negras':
           if ((e[0].type).toLowerCase().includes('pdf')) {
             this.myForm.patchValue({ fileLnegras: e[0] });
             break;
           } else {
             swal2.fire('El archivo tiene que ser un PDF','','info');
             break;
           }
           case 'Alta siac':
           if ((e[0].type).toLowerCase().includes('pdf')) {
             this.myForm.patchValue({ fileAsiac: e[0] });
             break;
           } else {
             swal2.fire('El archivo tiene que ser un PDF','','info');
             break;
           }
       }
    } */

  visualizarPDF(e, file, archivoNombre, formKey, idd){
    
    if (file && file.type === 'application/pdf') {
      this.visualizador = true;
      const fileURL = URL.createObjectURL(file);
      this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
      this.fileDetails = {
        name: archivoNombre,
        type: file.type,
        archivoNombre: archivoNombre,
        formKey: formKey,
        identificador: archivoNombre,
        idd: idd,
        input: e
      }
    } else {
      this.pdfSrc = null;
    }
  }

  async fileBrowseHandler( e: any, name: string, idd ) {
    const file: File = e.target.files[0];
    this.file = file;
    console.log(file)

    if (!name.toUpperCase().includes('XML') && file && file.type !== 'application/pdf') {
      swal2.fire('Atención', 'Solo se permiten archivos PDF', 'info');
      e.target.value = ''; // Limpia el input
      return;
    }
    if (name.toUpperCase().includes('XML') && file && file.type !== 'text/xml') {
      swal2.fire('Atención', 'Solo se permiten archivos XML', 'info');
      e.target.value = ''; // Limpia el input
      return;
    }

    if (name.toUpperCase().includes('XML') && file && file.type === 'text/xml') {
      this.readXml(file, idd, e);
    }

    if(file && file.type === 'application/pdf'){
      this.visualizarPDF(e, file, name, name, idd);
    }
    
  }

  async callupload(file, idu, idd) {
    try {
      const r = await this.aws.uploadFileSB(file, idu)
      var params = {};
      var user_document = {
        url: r['url'],
        status: 'IN',
      };
      params['user_document'] = user_document;
      let rp =  this.aws.patchUrlreemplazo(this.contributor_id, idd, r['url']).subscribe(r => {
        console.log(r)
          swal2.fire({
              title: 'Exito', 
              text: 'Archivo cargado correctamente', 
              icon: 'success',
              showConfirmButton: true,
              allowOutsideClick: false
            }).then(res => {
              if(res.value){
                this.ngOnInit();
                if(!this.archivosCargados.includes(idd)){
                  this.archivosCargados.push(idd);
                }
              }
            });
        }, err => {
            console.log('error', err);
            try{
              swal2.fire('Atención', err.error.errors[0], 'info');
            }catch{
              swal2.fire('Atención', 'Algo salió mal', 'info');
            }
          })
      // }
      return r['url'];
    } catch (error) {
      console.log('error', error);
      let resp = {
        status: false,
        resp: error,
        msg: 'Fallo al subir archivo'
      }
      try{
        swal2.fire(error.error.error, error.error.exception, 'info');
      }catch{
        swal2.fire('Error', 'Ocurrió algo en la carga', 'info')
      }
      return resp
    }
  }

  async subirarchivosNomina(e) {
    this.ingresos.push(e.target.files[0]);
    if((this.customerFG.get('salary_period')?.value?.toUpperCase() == 'QUINCENAL' && this.ingresos.length == 2) ||
       (this.customerFG.get('salary_period')?.value?.toUpperCase() == 'SEMANAL' && this.ingresos.length == 4) ){
         this.pendingIngresos = true;
         swal2.fire('Comprobantes listos', 'Se subirán al guardar cambios', 'info');
    }
  }

  async calluploadmulti(files, idu) {
    try {
      const r = await this.aws.uploadFilessSB(files, idu)
      return r
    } catch (error) {
      
    }
  }
    
  get activeFormGroup() {
    return this.formGroups[this.activeStep];
  }

  async hide(){
    this.visualizador = false;
    await this.callupload(this.file, this.idu, this.fileDetails['idd']);
  }

  archivoIncorrecto(){
    this.fileDetails['input'].target.value = '';
    this.visualizador = false;
  }

  get referenciasFA(): FormArray {
    return this.personalReferencesArray.get('referencias') as FormArray;
  }

  async seguirEditando(){
    if(this.cliente){
      swal2.fire('Éxito', 'Información actualizada correctamente', 'success');
      return
    }
    const result = await swal2.fire({
      title: '¿Deseas seguir editando?',
      // text: 'Tienes cambios sin guardar.',
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Seguir editando',
      cancelButtonText: 'Salir',
      allowOutsideClick: false,
      allowEscapeKey: false,
    });

    // Usuario quiere seguir editando
    if (result.isConfirmed) {
      // 👉 TU ACCIÓN AQUÍ
    }

    // Usuario quiere salir
    if (result.isDismissed) {
      this.router.navigate(['/modregemp']);
    }
  }

  goRequest(){
    localStorage.setItem('sec', 'true');
    this.router.navigate(['/maincliente/solicitudcredito']);
  }

  borradocatta(id){
    const index = this.archivosCargados.indexOf(id);
    if (index !== -1) {
      this.archivosCargados.splice(index, 1);
    }
  }
    
  async guardaCambios() {
    swal2.showLoading();
    var formgroup;
    var hasBankChange = false;
    Object.keys(this.pendingUpdates).forEach( k => {
      formgroup = this.formGroups[k];
      switch (formgroup) {
        case 'person':
          console.log('person', this.pendingUpdates[k]);
          this.contribuyenteService.actualizarPersonaFisica(this.person_id, this.pendingUpdates[k]).subscribe( r => {
            console.log(r);
            this.seguirEditando();
          }, err => {
            console.log(err);
            swal2.fire('Atención','Algo salió mal, contacte al administrador','info');
          });
          break;
        case 'contributorAddress':
          console.log('contributorAddress', this.pendingUpdates[k]);
          this.contribuyenteService.actualizarContributorAddress(this.contributor_id, this.pendingUpdates[k], this.contributorAddress_id).subscribe( r => {
            console.log(r);
            this.seguirEditando();
          }, err => {
            console.log(err);
            swal2.fire('Atención','Algo salió mal, contacte al administrador','info');
          });
          break;
        case 'personalReferences':
          console.log('personalReferences', this.pendingUpdates[k]);
          this.contribuyenteService.updateCustomerPersonalReferences(this.pendingUpdates[k]['referencias'][0].id, {customer_personal_reference: this.pendingUpdates[k]['referencias'][0].changes}).subscribe( r => {

          });
          break;
        case 'customer':
          console.log('customer', this.pendingUpdates[k]);
          this.contribuyenteService.updateCustomer(this.contributor_id, {customer: this.pendingUpdates[k]}, this.customer_id).subscribe( r => {
            console.log(r);
            this.seguirEditando();
          }, err => {
            console.log(err);
            swal2.fire('Atención','Algo salió mal, contacte al administrador','info');
          });
          break;
        case 'contributor':
          console.log('contributor', this.pendingUpdates[k]);
          const pendingContributor = this.pendingUpdates[k];
          const bankFields = ['bank', 'account_number', 'clabe', 'contributor_type'];
          const editedBankFields = bankFields.some(field => pendingContributor.hasOwnProperty(field));

          if (editedBankFields) {
            hasBankChange = true;
            // Cerrar el loading antes de mostrar el swal de motivo
            swal2.close();
            // Pedir motivo del cambio antes de enviar
            swal2.fire({
              title: 'Motivo del cambio de datos bancarios',
              input: 'textarea',
              inputLabel: '¿Por qué se modifican los datos bancarios?',
              inputPlaceholder: 'Describe el motivo del cambio...',
              inputValidator: (value) => {
                if (!value || value.trim().length === 0) {
                  return 'Debes ingresar un motivo';
                }
                return null;
              },
              showCancelButton: true,
              confirmButtonText: 'Guardar',
              cancelButtonText: 'Cancelar'
            }).then((result) => {
              if (result.isConfirmed) {
                const body = {
                  contributor: pendingContributor,
                  change_reason: result.value
                };
                this.contribuyenteService.updateContributor(this.contributor_id, body).subscribe(r => {
                  console.log(r);
                  this.seguirEditando();
                }, err => {
                  console.log(err);
                  swal2.fire('Atención', 'Algo salió mal, contacte al administrador', 'info');
                });
              }
            });
          } else {
            this.contribuyenteService.updateContributor(this.contributor_id, {contributor: pendingContributor}).subscribe(r => {
              console.log(r);
              this.seguirEditando();
            }, err => {
              console.log(err);
              swal2.fire('Atención', 'Algo salió mal, contacte al administrador', 'info');
            });
          }
          break;
        default:
          break;
      }
    });
    // Subir XML pendiente si existe
    if (this.pendingXmlFile) {
      await this.callupload(this.pendingXmlFile.file, this.idu, this.pendingXmlFile.idd);
      this.pendingXmlFile = null;
    }
    // Subir comprobantes de ingresos pendientes si existen
    if (this.pendingIngresos && this.ingresos.length > 0) {
      let resul = await this.calluploadmulti(this.ingresos, this.idu);
      var iddIngresos = this.contributor_documents.find(d => d.name.toLowerCase().includes('ingresos')).id;
      this.aws.patchUrlreemplazo(this.contributor_id, iddIngresos, resul[resul.length - 1]).subscribe(r => {
        console.log('Comprobantes de ingresos subidos', r);
      }, err => {
        console.log('Error subiendo comprobantes', err);
      });
      this.pendingIngresos = false;
    }
    if (!hasBankChange) {
      swal2.close();
    }
    this.pendingUpdates = {};

  /* (await this.aws.PatchPFcustomerConsulta(this.regUsuario.datosEspeciales.person_id, this.regUsuario.datosPersonales.nombre)).subscribe(
    async r =>{
        this.regUsuario.datosEspeciales.contributor_id = r.data.relations.contributors[0].id;
        this.regUsuario.datosEspeciales.customer_id = r.data.relations.customers[0].id;
        this.regUsuario.datosEspeciales.contributor_addres_id = r.data.relations.contributor_addresses[0].id;
        this.regUsuario.datosEspeciales.customer_pr_id = r.data.relations.customer_personal_references[0].id;
        for await (const i of r.data.relations.customer_personal_references) {
          if (i.attributes.first_name === this.regUsuario.refPers[0].nombrenf1control) {
            this.regUsuario.refPers[0].idcontrolnf1 = i.attributes.id
          } else if (i.attributes.first_name === this.regUsuario.refPers[1].nombrenf2control) {
            this.regUsuario.refPers[1].idcontrolnf2 = i.attributes.id
          } else if (i.attributes.first_name === this.regUsuario.refPers[2].nombrefamcontrol) {
            this.regUsuario.refPers[2].idcontrolfam = i.attributes.id
          }
      } */
        /* (await this.aws.PatchPFcustomer({lo_que: 'se'})).subscribe(r => {//console.log(r)
        
          swal2.fire({
              title: 'Exito', 
              text: 'Modificación de información exitosa', 
              icon: 'success',
              showConfirmButton: true,
              allowOutsideClick: false
            }).then(res => {
              if(res.value){
              if(this._router.snapshot.paramMap.get('cliente')){
                console.log('es cliente');
                this.router.navigate(['/maincliente/solicitudcredito']);
              }else{
                console.log('no es cliente');
                this.router.navigate(['/modregemp']);
              }
              }
            });
        }) */
  
  }

  // --- XML parsing methods ---

  readXml(file: File, idd: any, event: any) {
    this.readFileXml(file).subscribe((doc: any) => {
      let jsonxml = this.xml2json(doc, '');
      let parsed;
      try {
        parsed = JSON.parse(jsonxml);
      } catch {
        swal2.fire('Error de lectura XML', 'Formato incorrecto', 'warning');
        event.target.value = '';
        return;
      }

      if (!parsed["cfdi:Comprobante"]) {
        swal2.fire('Error de lectura XML: mal formado', 'Consulte al administrador', 'warning');
        event.target.value = '';
        return;
      }

      // Validar antigüedad máxima de 1 mes
      var fechaComprobante = new Date(parsed["cfdi:Comprobante"].Fecha);
      var fechaHoy = new Date();
      var diff = fechaHoy.getTime() - fechaComprobante.getTime();
      var diff_dias = diff / (1000 * 60 * 60 * 24);
      if (diff_dias > 30) {
        swal2.fire('Atención', 'El comprobante debe tener una antigüedad máxima de 1 mes', 'info');
        event.target.value = '';
        return;
      }

      // Validar RFC del emisor contra la empresa del empleado
      try {
        var rfcEmisor = parsed["cfdi:Comprobante"]["cfdi:Emisor"].Rfc;
        if (this.company && this.company.rfc && rfcEmisor !== this.company.rfc) {
          swal2.fire('Atención', 'El RFC del emisor del XML no coincide con la empresa del empleado', 'info');
          event.target.value = '';
          return;
        }
      } catch {}

      // Validaciones pasaron, marcar como cargado
      this.archivosCargados.push(idd);
      this.pendingXmlFile = { file: file, idd: idd };

      // Limpiar comprobantes de ingresos ya que el XML cambió
      this.ingresos = [];
      this.pendingIngresos = false;
      this.ingresosYaCargados = false;

      // Extraer datos personales
      try { this.personFG.patchValue({ imss: this.getValues(parsed, "NumSeguridadSocial")[0] }); } catch {}
      try { this.personFG.patchValue({ curp: this.getValues(parsed, "Curp")[0] }); } catch {}
      try { this.personFG.patchValue({ rfc: parsed["cfdi:Comprobante"]["cfdi:Receptor"].Rfc }); } catch {}

      // Nombre
      try {
        var nombreXML = parsed["cfdi:Comprobante"]["cfdi:Receptor"].Nombre;
        if (nombreXML) {
          var partes = nombreXML.split(' ');
          if (partes.length >= 3) {
            this.personFG.patchValue({
              first_name: partes.slice(0, partes.length - 2).join(' '),
              last_name: partes[partes.length - 2],
              second_last_name: partes[partes.length - 1]
            });
          }
        }
      } catch {}

      // Periodicidad de pago
      try {
        var claveFormaPago = parsed["cfdi:Comprobante"]["cfdi:Complemento"]["nomina12:Nomina"]["nomina12:Receptor"].PeriodicidadPago;
        if (claveFormaPago) {
          var mapPeriodo = { '01': 'DIARIO', '02': 'SEMANAL', '03': 'CATORCENAL', '04': 'QUINCENAL', '05': 'MENSUAL', '99': 'OTRA PERIODICIDAD' };
          var periodo = mapPeriodo[claveFormaPago] || claveFormaPago;
          this.customerFG.patchValue({ salary_period: periodo });
        }
      } catch {}

      // Sueldo
      try { this.customerFG.patchValue({ salary: this.getObjects(parsed, 'TipoPercepcion', '001')[0].ImporteGravado }); } catch {}

      // Retención IMSS
      try { this.customerFG.patchValue({ imms: this.getObjects(parsed, 'Concepto', "Aportación trabaj  IMSS")[0].Importe }); } catch {}

      // Bono puntualidad
      try { this.customerFG.patchValue({ ontime_bonus: this.getObjects(parsed, 'Concepto', 'Bono Puntualidad')[0].ImporteGravado }); } catch {}

      // Bono asistencia
      try { this.customerFG.patchValue({ assist_bonus: this.getObjects(parsed, 'Concepto', 'Bono Asistencia')[0].ImporteGravado }); } catch {}

      // Vales de despensa
      try { this.customerFG.patchValue({ food_vouchers: this.getObjects(parsed, 'Concepto', 'Vales de Despensa')[0].ImporteExento }); } catch {}

      // Fondo de ahorro
      try { this.customerFG.patchValue({ savings_found: this.getObjects(parsed, 'Concepto', 'Fondo Ahorro Empleado')[0].Importe }); } catch {}

      // Caja de ahorro
      try { this.customerFG.patchValue({ savings_bank: this.getObjects(parsed, 'Concepto', 'Caja de ahorro D')[0].Importe }); } catch {}

      // Préstamo fondo de ahorro
      try { this.customerFG.patchValue({ savings_found_loand: this.getObjects(parsed, 'Concepto', 'Préstamo Fondo Ahorro I')[0].Importe }); } catch {}

      // Infonavit
      try { this.customerFG.patchValue({ infonavit: this.getObjects(parsed, 'Concepto', 'Apor  crédito INFONAVIT')[0].Importe }); } catch {}

      // Impuestos
      try { this.customerFG.patchValue({ taxes: this.getValues(parsed, "TotalImpuestosRetenidos")[0] }); } catch {}

      // Puesto
      try {
        var puesto = parsed["cfdi:Comprobante"]["cfdi:Complemento"]["nomina12:Nomina"]["nomina12:Receptor"].Puesto;
        if (puesto) { this.customerFG.patchValue({ job: puesto }); }
      } catch {}

      // Antigüedad
      try {
        var fechaInicioRelacion = new Date(parsed["cfdi:Comprobante"]["cfdi:Complemento"]["nomina12:Nomina"]["nomina12:Receptor"].FechaInicioRelLaboral);
        var antiguedad = (fechaHoy.getTime() - fechaInicioRelacion.getTime()) / (1000 * 60 * 60 * 24 * 365);
        this.customerFG.patchValue({ seniority: antiguedad.toFixed(1) });
      } catch {}

      swal2.fire('Éxito', 'Datos del XML cargados correctamente', 'success');
    });
  }

  readFileXml(file: File): Observable<any> {
    const sub = new Subject<any>();
    var reader = new FileReader();
    reader.onload = () => {
      var xmlData = reader.result;
      var parser = new DOMParser();
      var doc = parser.parseFromString(xmlData.toString().replace('C<', 'u'), "text/xml");
      sub.next(doc);
      sub.complete();
    };
    reader.readAsText(file);
    return sub.asObservable();
  }

  getObjects(obj, key, val) {
    var objects = [];
    for (var i in obj) {
      if (!obj.hasOwnProperty(i)) continue;
      if (typeof obj[i] == 'object') {
        objects = objects.concat(this.getObjects(obj[i], key, val));
      } else if (i == key && obj[i].match(val) || i == key && val == '') {
        objects.push(obj);
      } else if (obj[i].match(val) && key == '') {
        if (objects.lastIndexOf(obj) == -1) {
          objects.push(obj);
        }
      }
    }
    return objects;
  }

  getValues(obj, key) {
    var objects = [];
    for (var i in obj) {
      if (!obj.hasOwnProperty(i)) continue;
      if (typeof obj[i] == 'object') {
        objects = objects.concat(this.getValues(obj[i], key));
      } else if (i == key) {
        objects.push(obj[i]);
      }
    }
    return objects;
  }

  xml2json(xml, tab) {
    var X = {
      toObj: function(xml) {
        var o: any = {};
        if (xml.nodeType == 1) {
          if (xml.attributes.length)
            for (var i = 0; i < xml.attributes.length; i++)
              o[xml.attributes[i].nodeName] = (xml.attributes[i].nodeValue || "").toString();
          if (xml.firstChild) {
            var textChild = 0, cdataChild = 0, hasElementChild = false;
            for (var n = xml.firstChild; n; n = n.nextSibling) {
              if (n.nodeType == 1) hasElementChild = true;
              else if (n.nodeType == 3 && n.nodeValue.match(/[^ \f\n\r\t\v]/)) textChild++;
              else if (n.nodeType == 4) cdataChild++;
            }
            if (hasElementChild) {
              if (textChild < 2 && cdataChild < 2) {
                X.removeWhite(xml);
                for (var n = xml.firstChild; n; n = n.nextSibling) {
                  if (n.nodeType == 3) o["#text"] = X.escape(n.nodeValue);
                  else if (n.nodeType == 4) o["#cdata"] = X.escape(n.nodeValue);
                  else if (o[n.nodeName]) {
                    if (o[n.nodeName] instanceof Array) o[n.nodeName][o[n.nodeName].length] = X.toObj(n);
                    else o[n.nodeName] = [o[n.nodeName], X.toObj(n)];
                  } else o[n.nodeName] = X.toObj(n);
                }
              } else {
                if (!xml.attributes.length) o = X.escape(X.innerXml(xml));
                else o["#text"] = X.escape(X.innerXml(xml));
              }
            } else if (textChild) {
              if (!xml.attributes.length) o = X.escape(X.innerXml(xml));
              else o["#text"] = X.escape(X.innerXml(xml));
            } else if (cdataChild) {
              if (cdataChild > 1) o = X.escape(X.innerXml(xml));
              else for (var n = xml.firstChild; n; n = n.nextSibling) o["#cdata"] = X.escape(n.nodeValue);
            }
          }
          if (!xml.attributes.length && !xml.firstChild) o = null;
        } else if (xml.nodeType == 9) {
          o = X.toObj(xml.documentElement);
        }
        return o;
      },
      toJson: function(o, name, ind) {
        var json = name ? ("\"" + name + "\"") : "";
        if (o instanceof Array) {
          for (var i = 0, n = o.length; i < n; i++) o[i] = X.toJson(o[i], "", ind + "\t");
          json += (name ? ":[" : "[") + (o.length > 1 ? ("\n" + ind + "\t" + o.join(",\n" + ind + "\t") + "\n" + ind) : o.join("")) + "]";
        } else if (o == null) json += (name && ":") + "null";
        else if (typeof(o) == "object") {
          var arr = [];
          for (var m in o) arr[arr.length] = X.toJson(o[m], m, ind + "\t");
          json += (name ? ":{" : "{") + (arr.length > 1 ? ("\n" + ind + "\t" + arr.join(",\n" + ind + "\t") + "\n" + ind) : arr.join("")) + "}";
        } else if (typeof(o) == "string") json += (name && ":") + "\"" + o.toString() + "\"";
        else json += (name && ":") + o.toString();
        return json;
      },
      innerXml: function(node) {
        var s = "";
        if ("innerHTML" in node) s = node.innerHTML;
        else {
          var asXml = function(n) {
            var s = "";
            if (n.nodeType == 1) {
              s += "<" + n.nodeName;
              for (var i = 0; i < n.attributes.length; i++) s += " " + n.attributes[i].nodeName + "=\"" + (n.attributes[i].nodeValue || "").toString() + "\"";
              if (n.firstChild) { s += ">"; for (var c = n.firstChild; c; c = c.nextSibling) s += asXml(c); s += "</" + n.nodeName + ">"; }
              else s += "/>";
            } else if (n.nodeType == 3) s += n.nodeValue;
            else if (n.nodeType == 4) s += "<![CDATA[" + n.nodeValue + "]]>";
            return s;
          };
          for (var c = node.firstChild; c; c = c.nextSibling) s += asXml(c);
        }
        return s;
      },
      escape: function(txt) {
        return txt.replace(/[\\]/g, "\\\\").replace(/[\"]/g, '\\"').replace(/[\n]/g, '\\n').replace(/[\r]/g, '\\r');
      },
      removeWhite: function(e) {
        e.normalize();
        for (var n = e.firstChild; n;) {
          if (n.nodeType == 3) {
            if (!n.nodeValue.match(/[^ \f\n\r\t\v]/)) { var nxt = n.nextSibling; e.removeChild(n); n = nxt; }
            else n = n.nextSibling;
          } else if (n.nodeType == 1) { X.removeWhite(n); n = n.nextSibling; }
          else n = n.nextSibling;
        }
        return e;
      }
    };
    if (xml.nodeType == 9) xml = xml.documentElement;
    var json = X.toJson(X.toObj(X.removeWhite(xml)), xml.nodeName, "\t");
    return "{\n" + tab + (tab ? json.replace(/\t/g, tab) : json.replace(/\t|\n/g, "")) + "\n}";
  }
}
